<template>
  <div class="price">
    <div class="banner outer">
      <!-- <div class="inside">
        <h1>立即提升招聘效率</h1>
        <p>80%的企业使用易猎云招聘管理系统后平均人效提升62%</p>
      </div> -->
      <div class="pricemessage">

        <div
          class="priec__box1"
          @click="selectclick(1)"
          :class="{ bordercolor: select1 }"
        >
          <h2 :class="{ select1Color: select1 }">
            免费版
            <!-- <img v-if="select1" src="../../../assets/icon_hot.svg" /> -->
          </h2>
          <div class="pricess">
            <span class="pr1s" :class="{ select1Color: select1 }">￥</span>
            <span class="pr2s" :class="{ select1Color: select1 }">0</span>
            <span class="pr4" :class="{ select1Color: select1 }">元/年</span>
          </div>
          <div class="threename" :class="{ select1Color: select1 }">限3个用户</div>
          <div class="describe">
            <img
              v-if="!select1"
              src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png"
            />
            <img v-if="select1" src="../../../assets/icon_pitch_on@2x.png" />
            <span :class="{ select1Color: select1 }"
              >适用于招聘顾问人数在3人以下的小型初创企业，终身免费</span
            >
          </div>
        </div>
        <div
          class="priec__box2"
          @click="selectclick(2)"
          :class="{ bordercolor: select2 }"
        >
          <h2 :class="{ select2Color: select2 }">
            标准版
            <!-- <img v-if="select2" src="../../../assets/icon_hot.svg" /> -->
          </h2>
          <div class="pricess">
            <span
              class="pr1"
              style="left:54px"
              :class="{ select2Color: select2 }"
              >￥</span
            >
            <span
              class="pr2"
              style="left: 78px"
              :class="{ select2Color: select2 }"
              >999</span
            >
            <span class="pr3" :class="{ select2Color: select2 }">元/年/人</span>
          </div>
          <div class="threename"></div>
          <div class="describe">
            <!-- <div class="describe_teshu">
              <img
                src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_presented@2x.png"
              />
              <span :class="{ select2Color: select2 }"
                >首次开通赠送21天免费体验时长</span
              >
            </div> -->
            <img
              v-if="!select2"
              src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png"
            />
            <img v-if="select2" src="../../../assets/icon_pitch_on@2x.png" />
            <span :class="{ select2Color: select2 }"
              >适用于追求效率和灵活性的中小型RPO企业</span
            >
          </div>
        </div>
        <div
          class="priec__box3"
          @click="selectclick(3)"
          :class="{ bordercolor: select3 }"
          :style="{ 'border-color':select3?'#c3d4e7':'#FF6B6B'}"
        >
        <img class="icon_conner" src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/icon_corner%20mark%402ssx.png"/>
        <!-- <div class="flagtab"></div>
        <span class="flagtabtext">推荐</span> -->
          <h2 :class="{ select4Color: select3 }">
            专业版
            <!-- <img v-if="select4" src="../../../assets/icon_hot.svg" /> -->
          </h2>
          <div class="pricess">
            <span
              class="pr1"
              :class="{ select4Color: select3 }"
              >￥</span
            >
            <span
              class="pr2"
              style="left:65px"
              :class="{ select4Color: select3 }"
              >1320</span
            >
            <span class="pr3" style="left:165px" :class="{ select4Color: select3 }">元/年/人</span>
          </div>
          <div class="threename" ></div>
          <div class="describe">
            <img
              v-if="!select3"
              src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png"
            />
            <img v-if="select3" src="../../../assets/icon_pitch_on@2x.png" />
            <span :class="{ select4Color: select3 }"
              >适用于有移动办公、私域流量、渠道交付需求的中大型RPO企业</span
            >
          </div>
        </div>
        <div
          class="priec__box4"
          @click="selectclick(4)"
          :class="{ bordercolor: select4 }"
        >

          <h2 :class="{ select4Color: select4 }">
            旗舰版
            <!-- <img v-if="select4" src="../../../assets/icon_hot.svg" /> -->
          </h2>
          <div class="pricess">
            <span
              class="pr1"
              :class="{ select4Color: select4 }"
              >￥</span
            >
            <span
              class="pr2"
              style="left:65px"
              :class="{ select4Color: select4 }"
              >1680</span
            >
            <span class="pr3" style="left:165px"  :class="{ select4Color: select4 }">元/年/人</span>
          </div>
          <div class="threename"></div>
          <div class="describe">
            <img
              v-if="!select4"
              src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png"
            />
            <img v-if="select4" src="../../../assets/icon_pitch_on@2x.png" />
            <span :class="{ select4Color: select4 }"
              >适用于同时拥有RPO和HRO业务，且有较高管理需求的中大型RPO企业</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="bgimgbox outer">
      <div class="inside1490">
        <h2 class="bgimg__title">套餐权益对比</h2>
      </div>
      <div class="bgimg__table">
        <div class="bg__title">
          <p class="sp1">功能</p>
          <p class="sp1" >免费版</p>
          <p class="sp1" >标准版</p>
          <p class="sp1" >专业版</p>
          <p class="sp1" >旗舰版</p>
        </div>
        <div class="keyong_table">
          <ul>
            <li
             style="position:relative"
              v-for="(item, index) in keyonglist"
              :key="index"
              :class="{ keyong_table_w: (index % 2) - 1 !== 0 }"
            >
              <p class="k1">{{ item.name }}
                <span class="dw_tool"> 
                  <p v-show="tindex==index" class="dw_box">{{item.tips}}</p>
                  <img class="icon_tips" @mouseenter="tipshow(index)"
                   @mouseleave="tipshowno()"
                    v-show="item.name=='系统外呼'||item.name=='招聘渠道整合'||item.name=='简历快照数量'||item.name=='交付渠道数量'||item.name=='结算设置'||item.name=='招聘助手易猎简历'||item.name=='招聘助手匹配度'" 
                    src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                </span>
                <!-- <el-tooltip class="item" effect="light" placement="top" popper-class="tableTypePopperClass">
                  <div slot="content">{{item.tips}}</div>
                <img class="icon_tips" v-show="item.name=='系统外呼'||item.name=='招聘渠道整合'||item.name=='简历快照数量'||item.name=='交付渠道数量'||item.name=='结算设置'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                </el-tooltip> -->
                <!-- <el-tooltip class="item" effect="light" placement="top" popper-class="tableTypePopperClass">
                  <div slot="content">把招聘平台的候选人与系统人才库进行精准匹配，将完全匹配的同一候选人显示易猎简历标识</div>
                <img class="icon_tips2" v-show="item.name=='招聘助手易猎简历'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                </el-tooltip>
                <el-tooltip class="item" effect="light" placement="top" popper-class="tableTypePopperClass">
                  <div slot="content">把招聘平台的候选人与招聘职位要求进行匹配度计算，浏览简历时即可查看候选人与招聘要求的匹配度</div>
                <img class="icon_tips2" style="left: 215px;" v-show="item.name=='招聘助手匹配度'" src="../../../assets/icon/icon_tips_orange@2x.png" alt=""/>
                </el-tooltip> -->
              </p>
              <p class="k2">{{ item.free }}</p>
              <p class="k3">{{item.fast}}</p>
              <p class="k4">{{ item.startup }}</p>
              <p class="k5">{{ item.standard }}</p>
              <!-- <div
                class="leftImg"
                @mousemove="leftImg = true"
                @mouseout="leftImg = false"
              >
                <img v-if="item.name=='系统外呼'" src="../../../assets/icon/icon_tips_orange@2x.png" alt="" />
                <div v-if="leftImg&&item.name=='系统外呼'">可通过系统一键外呼候选人，支持APP外呼，运营商线路外呼以及工作手机等外呼方式，可自动记录通话录音。</div>
              </div> -->
            </li>
          </ul>
        </div>
        <div class="upper">服务标准</div>
        <div class="service__table">
          <ul>
            <li class="service__table_w">
              <span class="s1">服务等级</span>
              <span class="s1">基本服务</span>
              <span class="s1">高级服务</span>
              <span class="s1">高级服务</span>
              <span class="s1">尊享服务</span>
            </li>
            <li
              v-for="(item, index) in servicelist"
              :key="index"
              class="service__table_s"
              :class="'bg' + (index % 2)"
            >
              <p class="icon_box">{{ item.name }}</p>
              <p class="icon_box"><img :class="index == 0 || index == 1 || index == 2? 'ic1' : 'ic3'" :src="item.free"/></p>
              <p class="icon_box" ><img :class="index == 6 ? 'ic3' : 'ic1'" :src="item.fastimg" /></p>
              <p class="icon_box"><img :class="index == 6 ? 'ic3' : 'ic1'" :src="item.startup" /></p>
              <p class="icon_box"><img class="ic1" :src="item.standard"/></p>
            </li>
          </ul>
        </div>
        <!-- <div class="button__table">
          <p style="margin-left:395px" @click="trial('1')">免费开通</p>
          <p style="background: #fb983c;margin-left:184px" @click="trial('1')">申请试用</p>
          <p style="background: #fb983c;margin-left:194px" @click="trial('3')">申请试用</p>
          <p @click="trial('2')" style="background: #fb983c;margin-left:184px">申请试用</p>
        </div> -->
        <div class="legendbox">
          <div class="lengendcontainer">
            <span class="lengendtitle">图例:</span>
            <p class="lengend__img">
              <img
                class="imga"
                src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png"
              /><span>全部功能</span>
            </p>
            <!--            <p class="lengend__img"><img class="imgb"-->
            <!--                                         src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_exclamation@2x.png"/><span>部分功能</span>-->
            <!--            </p>-->
            <p class="lengend__img">
              <img
                class="imgc"
                src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_on-2x.png"
              /><span>不包含此功能</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; height: 1554px; background: #ffffff"></div>

    <div class="sizeservice outer">
      <div class="inside1490" style="position: relative;">
        <span class="tips_text">注：简历容量标准版免费额度20万份/年，专业版免费额度60万份/年，旗舰版容量不受限制，超过容量后每20万份简历存储费用1000元/年</span>
        <div class="servicebox">
          <p>计次服务</p>
          <div class="service__textbox">
            <div class="fl">
              <div class="se_child" style="margin-top: 40px">
                <img
                  src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png"
                />
                <span>电子合同</span>
              </div>
              <div class="se_child" style="margin-top: 47px">
                <img
                  src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png"
                />
                <span>呼叫中心语音外呼</span>
              </div>
            </div>
            <div class="fr">
              <div class="sr_child" style="margin-top: 30px">
                <span class="money">￥</span>
                <span class="moneynumber">1.5</span>
                <span class="moneytext3">元/份</span>
              </div>
              <div class="sr_child" style="margin-top: 30px">
                <span class="money">￥</span>
                <span class="moneynumber">0.12</span>
                <span class="moneytext2"
                  >元/分钟，每坐席单月最低消费20元。</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="apply outer">
      <div class="inside trial">
        <h2>即刻开启数字化招聘人效提升之旅</h2>
        <p @click="trial('')">申请试用</p>
      </div>
    </div> -->
    <!--申请试用组件-->
    <populone v-if="windowflags" :isshow="windowflags" :selectId="selectId" :he="true" @handleChange="changewindows" />
  </div>
</template>
<script>
import populone from "@/components/views/popul/populone";

export default {
  name: "price",
  data() {
    return {
      tindex:-1,
      selectId:'',
      routeData:{},
      leftImg:false,
      windowflags: false,
      select1: false,
      select2: false,
      select3: false,
      select4: false,
      windowflag: false,
      defflag: "",
      windowfla: false,
      deffla: "",
      keyonglist: [
        {
          name: "账号数",
          free: "3个以内",
          fast:'按需',
          startup: "按需",
          standard: "按需",
          tips:''
        },
        {
          name: "系统外呼",
          free: "-",
          fast:'-',
          startup: "支持",
          standard: "支持",
          tips:'可通过系统一键外呼候选人，支持APP外呼，运营商线路外呼以及工作手机等外呼方式，可自动记录通话录音。'
        },
        {
          name: "通话录音",
          free: "-",
          fast:'-',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "招聘渠道整合",
          free: "支持",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:'支持BOSS直聘，智联招聘，前程无忧，58招聘，猎聘，快手等主流招聘平台，招聘顾问可以直接在招聘平台上一键入库，外呼和评价'
        },
        {
          name: "招聘助手自动入库",
          free: "-",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "招聘助手匹配度",
          free: "-",
          fast:'-',
          startup: "支持",
          standard: "支持",
          tips:'把招聘平台的候选人与招聘职位要求进行匹配度计算，浏览简历时即可查看候选人与招聘要求的匹配度'
        },
        {
          name: "招聘助手易猎简历",
          free: "-",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:'把招聘平台的候选人与系统人才库进行精准匹配，将完全匹配的同一候选人显示易猎简历标识'
        },
        // {
        //   name: "业务规则配置",
        //   free: "--",
        //   startup: "--",
        //   standard: "支持",
        // },
        {
          name: "简历快照数量",
          free: "1",
          fast:'2',
          startup: "3",
          standard: "3",
          tips:'允许查看候选人简历多次投递简历附件的最大数量'
        },
        {
          name: "人才库",
          free: "支持",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "招聘进程管理",
          free: "支持",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "职位管理",
          free: "支持",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "统计报表",
          free: "基础报表",
          fast:'全功能报表',
          startup: "全功能报表",
          standard: "全功能报表",
          tips:''
        },
        {
          name: "个性化显示",
          free: "-",
          fast:'自定义域名+logo自定义',
          startup: "自定义域名+logo自定义",
          standard: "自定义域名+logo自定义",
          tips:''
        },
        {
          name: "交付渠道数量",
          free: "-",
          fast:'-',
          startup: "10",
          standard: "不限",
          tips:'邀请第三方招聘公司协助交付候选人'
        },
        {
          name: "简历批量导出",
          free: "支持",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "候选人保护期",
          free: "-",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "结算设置",
          free: "-",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:'支持多种结算方式，支持自动和手动结算，方便统计顾问的业绩'
        },
        {
          name: "微信绑定",
          free: "-",
          fast:'支持',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "移动端交付",
          free: "-",
          fast:'-',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "移动端管理看板",
          free: "-",
          fast:'-',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "微信分享小程序",
          free: "-",
          fast:'-',
          startup: "支持",
          standard: "支持",
          tips:''
        },
        {
          name: "HRO人事管理",
          free: "-",
          fast:'-',
          startup: "-",
          standard: "支持",
          tips:''
        },
        {
          name: "电子合同",
          free: "-",
          fast:'-',
          startup: "-",
          standard: "支持",
          tips:''
        },
        {
          name: "简历容量",
          free: "限1万份简历",
          fast:'限20万份/年，可增购',
          startup: "限60万份/年，可增购",
          standard: "不限",
          tips:''
        },
      ],
      servicelist: [
        {
          name: "产品文档",
          free: "https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          startup:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          fastimg:'https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png',
          standard:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          tips:''
        },
        {
          name: "产品培训视频",
          free: "https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          startup:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          fastimg:'https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png',
          standard:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          tips:''
        },
        {
          name: "在线客服",
          free: "https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          startup:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          fastimg:'https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png',
          standard:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          tips:''
        },
        {
          name: "使用答疑",
          free: "https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_on-2x.png",
          startup:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          fastimg:'https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png',
          standard:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          tips:''
        },
        {
          name: "开通培训",
          free: "https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_on-2x.png",
          startup:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          fastimg:'https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png',
          standard:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          tips:''
        },
        {
          name: "专属客户成功",
          free: "https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_on-2x.png",
          startup:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          fastimg:'https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png',
          standard:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          tips:''
        },
        {
          name: "同城上门培训",
          free: "https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_on-2x.png",
          startup:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_on-2x.png",
          fastimg:'https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_on-2x.png',
          standard:"https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_pitch_on@2x.png",
          tips:''
        },
      ],
    };
  },
  metaInfo: {
      title: '易猎云产品价格-更适合RPO批量招聘场景的免费招聘系统',
      meta: [
        {
          name: 'keywords',
          content: '易猎云产品价格，产品报价，招聘管理系统，免费，free，批量招聘，数字化'
        },
        {
          name: 'description',
          content: '易猎云招聘管理系统产品价格，RPO公司批量招聘数字化首选的招聘系统'
        }
      ]
    },
  mounted(){
    if (Object.keys(this.$route.query).length) {
      this.routeData = this.$route.query;
    }
    const { u = "" } = this.routeData;
    if (!u) {
      console.log("官网价格");
      zhuge.track("官网价格页", {
        渠道: "pc",
        utm类型: "自然流量",
      });
    } else {
      zhuge.track("官网价格页", {
        渠道: "pc",
        utm类型: "驱动流量",
      });
    }
  },
  components: {
    populone,
  },
  methods: {
    changewindows(value) {
      this.windowflags = value;
    },
    selectclick(id) {

      if (id == 1) {
        this.select1 = true;
        this.select2 = false;
        this.select3 = false;
        this.select4 = false;
      } else if (id == 2) {
        this.select1 = false;
        this.select2 = true;
        this.select3 = false;
        this.select4 = false;
      } else if (id == 3) {
        this.select1 = false;
        this.select2 = false;
        this.select3 = true;
        this.select4 = false;
      } else if (id == 4) {
        this.select1 = false;
        this.select2 = false;
        this.select3 = false;
        this.select4 = true;
      }
    },
    trial(id) {
      this.selectId='';
      console.log(this.selectId,'@@@');
      this.windowflags = true;
    },
    changewindo(value) {
      this.windowfla = value;
    },
    tipshow(index){
      this.tindex=index;
    },
    tipshowno(){
      this.tindex=-1;
    }
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/style/index.less";

.price {
  .banner {
    position: relative;
    width: 100%;
    height: 288px;
    background: #e7f2ff;
    padding-top: 90px;

    h1 {
      font-size: 70px;
      color: #1d2754;
      line-height: 112px;
      text-align: center;
    }

    p {
      font-size: 24px;
      font-weight: 500;
      color: #3a4d70;
      line-height: 30px;
      text-align: center;
      margin-top: 29px;
    }
  }

  .pricemessage {
    display: flex;
    position: absolute;
    width: 1490px;
    height: 390px;
    justify-content: space-between;
    left: 50%;
    transform: translateX(-50%);
    top: 52px;
    z-index: 10;

    .priec__box1 {
      position: relative;
      width: 338px;
      background: #ffffff;
      border-radius: 11px;
      border: 2px solid #c3d4e7;
      cursor: pointer;
    }

    .priec__box2 {
      position: relative;
      width: 338px;
      margin-left: 16px;
      background: #ffffff;
      border-radius: 11px;
      border: 2px solid #c3d4e7;
      cursor: pointer;
    }

    .priec__box3 {
      position: relative;
      width: 338px;
      margin-left: 16px;
      background: #ffffff;
      border-radius: 11px;
      border: 2px solid #FF6B6B;
      cursor: pointer;
      .icon_conner{
        position: absolute;
        width: 70px;
        top: -11px;
        left: -1px;
      }
      .flagtab{
        position: absolute;
        top: -6px;
        left: -33px;
        width:100px;
        height: 0;
        border-bottom: 48px solid #FF6B6B;
        border-left: 48px solid transparent;
        border-right: 48px solid transparent;
        transform: rotate(-45deg);
      }
      .flagtabtext{
          position: absolute;
          top: 15px;
          left: 5px;
          font-size: 18px;
          color: #FFFFFF;
          transform: rotate(-45deg);
        }
    }

    .priec__box4 {
      position: relative;
      width: 338px;
      margin-left: 16px;
      background: #ffffff;
      border-radius: 11px;
      border: 2px solid #c3d4e7;
      cursor: pointer;
    }

    .bordercolor {
      /*border: 2px solid #0084FF;*/
      background: #0084ff;
    }

    .select4Color {
      color: #fff !important;
      position: relative;

      img {
        position: absolute;
        left: 100px;
        top: 4px;
        width: 46px;
        height: 31px;
      }
    }

    .select2Color {
      color: #fff !important;
      position: relative;

      img {
        position: absolute;
        left: 100px;
        top: 4px;
        width: 46px;
        height: 31px;
      }
    }

    .select1Color {
      color: #fff !important;
      position: relative;

      img {
        position: absolute;
        left: 100px;
        top: 4px;
        width: 46px;
        height: 31px;
      }
    }

    .price__select {
      position: absolute;
      width: 81px;
      height: 85px;
      top: 0px;
      right: -1px;
    }

    h2 {
      font-size: 28px;
      font-weight: 400;
      color: #1d2754;
      line-height: 45px;
      text-align: center;
      margin-top: 40px;
    }

    p {
      font-size: 22px;
      font-weight: 100;
      color: #8c8fa1;
      line-height: 30px;
      text-decoration: line-through;
    }

    .pricess {
      width: 100%;
      height: 62px;
      margin-top: 30px;
      position: relative;

      .pr1 {
        position: absolute;
        font-size: 20px;
        color: #000000;
        left: 45px;
        top: 5px;
      }

      .pr1s {
        position: absolute;
        font-size: 20px;
        color: #000000;
        left: 101px;
        top: 5px;
      }

      .pr2 {
        position: absolute;
        font-size: 44px;
        color: #1d2754;
        line-height: 62px;
        left: 36px;
        font-weight: 510;
      }

      .pr2s {
        position: absolute;
        font-size: 44px;
        color: #1d2754;
        line-height: 62px;
        left: 120px;
        font-weight: 510;
      }

      .pr3 {
        position: absolute;
        font-size: 24px;
        color: #686d85;
        line-height: 70px;
        left: 150px;
      }

      .pr4 {
        position: absolute;
        font-size: 24px;
        color: #686d85;
        line-height: 70px;
        left: 144px;
      }
    }
    .threename{
      width: 100%;
      height: 20px;
      text-align: center;
      color: #1D2754;
      font-size: 22px;
      margin-top: 10px;
    }
    .describe {
      position: relative;
      width: 100%;
      height: 100px;
      margin-top: 35px;

      .describe_teshu {
        /*width: 130px;*/
        /*height: 30px;*/
        position: absolute;
        top: -40px;
        margin-left: 14%;
        display: flex;
        align-items: center;

        img {
          width: 30px;
          height: 18px;
        }

        span {
          font-size: 12px;
          margin-top: 0;
          height: 30px;
        }
      }

      img {
        position: absolute;
        width: 28px;
        height: 21px;
        top: 5px;
        left: 37px;
      }

      span {
        position: absolute;
        display: inline-block;
        width: 210px;
        font-size: 18px;
        color: #1d2754;
        left: 75px;
        top: 0px;
        line-height: 33px;
      }
    }
  }

  .bgimgbox {
    position: relative;
    width: 100%;
    height: 677px;
    background-image: url("https://img.yilieyun.com/oss/ylyofficialWebImagse/bg_01@2x.png");
    background-repeat: repeat-x;
    background-size: 125% 100%;
    padding-top: 100px;

    .bgimg__text {
      position: relative;
      width: 1200px;
      height: 53px;
      margin: 0 auto;

      img {
        width: 62px;
        height: 43px;
        margin-left: 29px;
      }

      span {
        position: absolute;
        font-size: 28px;
        color: #1d2754;
        line-height: 32px;
        top: 5px;
        left: 110px;
      }
    }

    .bgimg__title {
      font-size: 33px;
      color: #1d2754;
      line-height: 33px;
      margin-top: 92px;
      text-align: center;
    }

    .bgimg__table {
      position: absolute;
      width: 1490px;
      background: #ffffff;
      border-radius: 11px;
      border: 2px solid #1990ff;
      z-index: 5;
      top: 263px;
      left: 50%;
      transform: translateX(-50%);
      .bg__title {
        display: flex;
        width: 100%;
        height: 86px;
        justify-content: space-between;
        border-bottom: 1px solid #1ea6fc;
        line-height: 86px;
        .sp1 {
          flex: 1;
          font-size: 18px;
          font-weight: 600;
          color: #1d2754;
          text-align: center;
        }
      }

      .upper {
        width: 100%;
        height: 52px;
        background: #ffffff;
        font-size: 18px;
        font-weight: 600;
        color: #1d2754;
        line-height: 52px;
        text-align: center;
      }

      .upper__talbe {
        width: 100%;
        height: 104px;
        border-bottom: 1px solid #1ea6fc;

        li {
          width: 100%;
          height: 52px;

          .t1 {
            display: inline-block;
            width: 126px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 143px;
          }

          .t2 {
            display: inline-block;
            width: 30px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 170px;
          }

          .t3 {
            display: inline-block;
            width: 40px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 170px;
          }

          .t4 {
            display: inline-block;
            width: 40px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 170px;
          }

          .t5 {
            display: inline-block;
            width: 51px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 150px;
          }
        }
      }

      .keyong_table {
        width: 100%;
        border-bottom: 1px solid #1ea6fc;
        li {
          width: 100%;
          font-size: 18px;
          color: #1d2754;
          line-height: 52px;
          justify-content: space-between;
          text-align: center;
          display: flex;
          .k1 {
            flex: 1;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
          
          }

          .k2 {
            flex: 1;
            height: 22px;
            text-align: center;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
          }

          .k3 {
            flex: 1;
            height: 22px;
            text-align: center;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
           
          }

          .k4 {
            flex: 1;
            height: 22px;
            text-align: center;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
          
          }

          .k5 {
            flex: 1;
            height: 22px;
            text-align: center;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
          
          }
        }
      }

      .service__table {
        width: 100%;
        height: 400px;
        border-bottom: 1px solid #1ea6fc;

        li {
          width: 100%;
          height: 52px;

          .r1 {
            display: inline-block;
            width: 72px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 171px;
          }

          .r2 {
            display: inline-block;
            width: 72px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 172px;
          }

          .r3 {
            display: inline-block;
            width: 72px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 142px;
          }

          .r4 {
            display: inline-block;
            width: 72px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 138px;
          }

          .r5 {
            display: inline-block;
            width: 72px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 129px;
          }

          .k1 {
            display: inline-block;
            width: 144px;
            height: 52px;
            font-size: 18px;
            color: #1d2754;
            line-height: 52px;
            text-align: center;
            margin-left: 134px;
          }

          .k21 {
            display: inline-block;
            width: 28px;
            height: 22px;
            text-align: center;
            margin-left: 161px;
          }

          .k3 {
            display: inline-block;
            width: 28px;
            height: 22px;
            text-align: center;
            margin-left: 182px;
          }

          .k4 {
            display: inline-block;
            width: 28px;
            height: 22px;
            text-align: center;
            margin-left: 182px;
          }

          .k5 {
            display: inline-block;
            width: 28px;
            height: 22px;
            text-align: center;
            margin-left: 170px;
          }
        }
      }

      .button__table {
        width: 100%;
        height: 118px;
        display: flex;
        border-top: 1px solid #1ea6fc;
        margin-top: 20px;
        p {
          width: 108px;
          height: 56px;
          text-align: center;
          background: #1990ff;
          border-radius: 11px;
          font-size: 20px;
          color: #ffffff;
          line-height: 56px;
          margin-top: 31px;
          cursor: pointer;
        }

        .buttonbox {
          /*display: inline-block;*/
          width: 108px;
          height: 56px;
          background: #1990ff;
          border-radius: 11px;
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 56px;
          margin-top: 28px;
          cursor: pointer;
        }
      }

      .legendbox {
        width: 100%;
        height: 96px;
        background: #f1f8ff;
        border-radius: 0px 0px 11px 11px;
        border-top: solid 1px #1ea6fc;
        margin-top: 20px;
        .lengendcontainer {
          width: 570px;
          height: 96px;
          margin-left: 520px;

          .lengendtitle {
            font-size: 20px;
            color: #1d2754;
            line-height: 96px;
          }

          .lengend__img {
            position: relative;
            display: inline-block;
            width: 157px;
            top: 0px;
            margin-left: 10px;

            .imga {
              position: relative;
              display: inline-block;
              width: 28px;
              height: 22px;
              top: 3px;
            }

            .imgb {
              position: relative;
              display: inline-block;
              width: 5px;
              height: 25px;
              top: 5px;
            }

            .imgc {
              position: relative;
              display: inline-block;
              width: 21px;
              height: 21px;
              top: 5px;
            }

            span {
              font-size: 20px;
              color: #1d2754;
              line-height: 74px;
              margin-left: 9px;
            }
          }
        }
      }
    }
  }

  .apply {
    width: 100%;
    height: 410px;
    background-image: url("https://img.yilieyun.com/oss/ylyofficialWebImagse/bg_blue_02@2x.jpg");
    background-repeat: no-repeat;
    background-size: 105%;
    padding-top: 119px;

    h2 {
      font-size: 50px;
      text-align: center;
      color: #ffffff;
      line-height: 70px;
    }

    p {
      width: 158px;
      height: 66px;
      background: #ffffff;
      border-radius: 7px;
      color: #0084ff;
      line-height: 66px;
      text-align: center;
      font-size: 24px;
      margin: 0 auto;
      margin-top: 53px;
      cursor: pointer;
    }
  }

  .sizeservice {
    width: 100%;
    height: 480px;
    background: #ffffff;
    padding-top: 65px;

    .servicebox {
      width: 100%;
      height: 385px;
      background: #fafafa;
      border-radius: 11px;
      border: 1px solid #d9d9d9;

      p {
        font-size: 32px;
        font-weight: 400;
        color: #1d2754;
        line-height: 45px;
        text-align: center;
        margin-top: 57px;
      }

      .service__textbox {
        margin-top: 58px;

        .se_child {
          width: 230px;
          position: relative;
          height: 40px;
          margin-left: 280px;

          img {
            position: absolute;
            width: 28px;
            height: 20px;
            top: 5px;
          }

          span {
            position: absolute;
            font-size: 24px;
            color: #1d2754;
            left: 37px;
            top: 0px;
          }
        }

        .sr_child {
          position: relative;
          width: 460px;
          height: 60px;
          margin-right: 124px;

          .money {
            position: absolute;
            font-size: 30px;
            left: 0px;
            top: 0px;
          }

          .moneynumber {
            position: absolute;
            font-size: 44px;
            color: #1d2754;
            left: 35px;
            top: 2px;
          }

          .moneytext {
            position: absolute;
            font-size: 20px;
            color: #1d2754;
            left: 100px;
            top: 9px;
            line-height: 30px;
          }

          .moneytext2 {
            position: absolute;
            font-size: 20px;
            color: #1d2754;
            left: 125px;
            top: 9px;
          }

          .moneytext3 {
            position: absolute;
            font-size: 20px;
            color: #1d2754;
            left: 98px;
            top: 9px;
          }
        }
      }
    }
  }

  .bg0 {
    background: #ffffff;
  }

  .bg1 {
    background: #fafafc;
  }

  .ic0 {
    margin-left: 8px;
    width: 5px;
    height: 25px;
  }

  .ic1 {
    width: 28px;
    height: 22px;
  }

  .ic3 {
    width: 24px;
    height: 22px;
  }
}

.keyong_table_w {
  background: #fafafc;
}

.service__table_w {
  position: relative;
  background: #fafafc;
  display: flex;
  justify-content: space-between;
  .s1{
    display: inline-block;
    flex: 1;
    height: 52px;
    font-size: 18px;
    color: #1d2754;
    line-height: 52px;
    text-align: center;
  }
}

.service__table_s {
  display: flex;
  .icon_box{
    position: relative;
    flex: 1;
    height: 22px;
    font-size: 18px;
    text-align: center;
    margin-top: 15px;
    img{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.leftImg {
        cursor: pointer;
        width: 20px;
        height: 20px;
        position: absolute;
        left: 193px;
        top: 15px;
        img {
          width: 100%;
          height: 100%;
        }
        div {
          width: 270px;
          height: 75px;
          background: url("../../../assets/icon/pic_rectangle@2x.png");
          background-size: 100% 100%;
          position: absolute;
          top: -82px;
          left: -124px;
          font-size: 18px;
          color: #ff572e;
          display: flex;
          justify-content: center;
          padding-top: 2px;
          line-height: 65px;
        }
      }
      .icon_tips{
        display:inline-block;
        width:16px;
        height:17px;
        margin-top:-1px;
        margin-left: 0px;
        vertical-align: middle;
        cursor: pointer;
      }
      .icon_tips2{
        position: absolute;
        display: inline-block;
        width:16px;
        height:17px;
        top: 18px;
        left: 225px;
        vertical-align: middle;
        cursor: pointer;
      }
      .tips_text{
        position: absolute;
        left: 0px;
        top: -37px;
        font-size: 16px;
        color: #ff572e;
      }
.dw_tool{
    position: relative;
}
.dw_box{  
    width: max-content;
    max-width: 450px;
    position: absolute;
    padding: 10px 8px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 30px;
    box-sizing: border-box !important;
    background-color:#fff9f5;
    border: solid 1px #FF572E;
    border-radius: 5px;
    text-indent: 0px;
    line-height: 20px;
    text-align: left;
    font-size: 14px;
    z-index: 9999;
    color: #FF572E!important;
    &::after{
        position: absolute;
        bottom: -17px;
        left: 50%;
        transform: translateX(-50%);
        content: '';
        width: 0;
        height: 0;
        border: 9px solid transparent;
        border-top-color: #FF572E; 
        z-index: 1;
    }
    &::before{
        position: absolute;
        bottom: -16px;
        left: 50%;
        transform: translateX(-50%);
        content: '';
        width: 0;
        height: 0;
        border: 9px solid transparent;
        border-top-color: #fff9f5; 
        z-index: 2;
    }
}
</style>
<style>
.el-tooltip__popper.is-light {
  background-color: #FFF6F4!important;
  border: 0.5px solid #FF572E!important;
  font-size: 14px !important;
}
.tableTypePopperClass {
  color: #FF572E!important;
  background-color: #fff9f5!important;
  border: 0.5px solid #fa9658!important;
  font-weight: normal!important;
  font-size: 12px;
  letter-spacing: 0px;
  font-stretch: normal;
  font-family: PingFangSC-Regular;
  padding: 10px 8px 10px;
  /* line-height: 20px; */
    max-width: 500px;
    /* color: #333!important; */
    line-height: 18px!important;
    /* border: 1px solid #EBEEF5!important; */
  }

  .tableTypePopperClass[x-placement^=bottom] .popper__arrow{
    border-bottom-color: #fa9658!important;
  }
  .tableTypePopperClass[x-placement^=bottom] .popper__arrow:after {
    border-bottom-color: #fff9f5!important;
  }

  .tableTypePopperClass[x-placement^=top] .popper__arrow{
    border-top-color: #fa9658!important;
  }
  .tableTypePopperClass[x-placement^=top] .popper__arrow:after {
    border-top-color: #fff9f5!important;
  }

  .el-select-dropdown__wrap{
    max-height: 259px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/price/pricetwo.vue